(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart"]) return;
  try {
    
(function () {
  function initializeCartNotices(root) {
    root.querySelectorAll('.ld-cart-form[data-ld-box-cart]').forEach(function (form) {
      if (form.dataset.ldNoticeReady) return;
      form.dataset.ldNoticeReady = 'true';
      var notice = form.querySelector('[data-ld-box-notice]');
      var checkout = form.querySelector('[data-ld-cart-checkout]');
      if (!notice || !checkout) return;

      function updateNotice() {
        var boxes = 0;
        var singles = 0;
        form.querySelectorAll('.ld-cart__quantity').forEach(function (input) {
          var quantity = Math.max(0, parseInt(input.value, 10) || 0);
          if (input.dataset.ldBox === 'true') boxes += quantity;
          else if (input.dataset.ldShippable === 'true') singles += quantity;
        });
        var overLimit = boxes > 5;
        var mixed = boxes > 0 && singles > 0;
        var blocked = overLimit;
        notice.hidden = boxes === 0;
        notice.classList.toggle('ld-box-cart-notice--blocked', blocked);
        notice.querySelector('[data-ld-box-count]').textContent = boxes;
        notice.querySelector('[data-ld-box-limit]').hidden = !overLimit;
        notice.querySelector('[data-ld-box-mixed]').hidden = !mixed || overLimit;
        notice.querySelector('[data-ld-box-policy]').hidden = blocked;
        notice.querySelector('[data-ld-box-italy]').hidden = blocked;
        checkout.disabled = blocked;
        if (boxes > 0) checkout.setAttribute('aria-describedby', notice.id);
        else checkout.removeAttribute('aria-describedby');
        return blocked;
      }

      form.addEventListener('input', function (event) {
        if (event.target.matches('.ld-cart__quantity')) updateNotice();
      });
      form.addEventListener('change', function (event) {
        if (event.target.matches('.ld-cart__quantity')) updateNotice();
      });
      form.addEventListener('click', function (event) {
        var button = event.target.closest('[data-ld-cart-minus], [data-ld-cart-plus]');
        if (!button) return;
        var control = button.closest('.ld-cart__quantity-control');
        var input = control && control.querySelector('.ld-cart__quantity');
        if (!input) return;
        var currentValue = parseInt(input.value || '0', 10);
        if (Number.isNaN(currentValue)) currentValue = 0;
        input.value = button.hasAttribute('data-ld-cart-plus') ? currentValue + 1 : Math.max(0, currentValue - 1);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
      form.addEventListener('submit', function (event) {
        if (event.submitter && event.submitter.name === 'checkout' && updateNotice()) {
          event.preventDefault();
          notice.focus();
        }
      });
      updateNotice();
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initializeCartNotices(document); });
  } else initializeCartNotices(document);
  document.addEventListener('shopify:section:load', function (event) { initializeCartNotices(event.target); });
})();

  } catch(e) { console.error(e); }
})();
})();
